import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EffectsModule } from '@ngrx/effects'
import { UtilityEffects } from './store/utility.effects'
import {
  TruncatePipe,
  LanguageNamePipe,
  SecureImagePipe,
  FullnamePipe,
  TitleCasePipe,
  CallPipe,
  CapitalizePipe,
  SnakeCasePipe,
  StartCasePipe,
  html2TextPipe,
} from './pipes'

import { RecaptchaService } from './services/recaptcha.service'
import { PopoverModule } from 'ngx-bootstrap/popover'
import { TooltipDirective } from './tooltip/tooltip.directive'
import { CircleProgressComponent } from './circle-progress/circle-progress.component'

const pipes = [
  //
  TruncatePipe,
  LanguageNamePipe,
  SecureImagePipe,
  FullnamePipe,
  TitleCasePipe,
  CallPipe,
  CapitalizePipe,
  SnakeCasePipe,
  StartCasePipe,
  html2TextPipe,
]
const components = [
  //
  CircleProgressComponent,
]

const directives = [TooltipDirective]

const modules = [PopoverModule]

@NgModule({
  imports: [CommonModule, ...modules, EffectsModule.forFeature([UtilityEffects])],
  declarations: [...pipes, ...directives, ...components],
  exports: [...pipes, ...directives, ...components, ...modules],
  providers: [RecaptchaService],
})
export class UtilityLibraryModule {}
